// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1e0c1txw{display:flex}\n._2lx2vrvc{flex-direction:row}\n._4cvr1h6o{align-items:center}\n._n3td1b66{padding-bottom:var(--ds-space-050,4px)}", ""]);
// Exports
module.exports = exports;
